import { defineStore } from "pinia"
// import { toRefs } from "vue"

interface MapState {
  globalLoading: boolean
  loading2dFinish: boolean
  mapType: string
  xzqhbm: any
  viewId: string
}

export const useMapStore = defineStore({
  id: "map",
  state: (): MapState => {
    return {
      globalLoading: false,
      loading2dFinish: false,
      mapType: "2d",
      xzqhbm: { code: "", searchTpye: "" },
      viewId: ""
    }
  },
  actions: {
    setGlobalLoading(state: boolean) {
      this.globalLoading = state
    },
    setLoading2dFinish(state: boolean) {
      this.loading2dFinish = state
    },
    setMapType(state: string) {
      this.mapType = state
    },
    setXzqhbm(state: any) {
      this.xzqhbm = state
    },
    setViewId(state: any) {
      this.viewId = state
    }
  }
})
